import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'app-cp-divider',
  imports: [],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: ` <p>cp-divider works!</p> `,
  styles: ``,
})
export class CpDividerComponent {}
